import moment from "moment";
import fetchAndTrackCubeQuery from "../../../../../Utils/UtilFunctions/trackedCubeQuery";

// const formChunkArray = (data: any, count: number) => {
// 	const result: any = []
// 	for (let i = 0; i < data.length; i += count) {
// 		result.push(data.slice(i, i + count))
// 	}
// 	return result
// }

const getTagsForTagsFilter = async ({
  tagsCube,
  cubejsApi,
  setTagFilterOptions,
  setTagFilterOptionsCopy,
  assetsForTagsFilter,
}: any) => {
  const baseTags: any = [];
  assetsForTagsFilter.map((tag: string) => {
    if (tag && tag !== "") {
      baseTags.push(tag);
    }
  });
  const tagsQuery1: any = {
    dimensions: [`${tagsCube?.name}.tagName`],
    filters: [
      {
        member: `${tagsCube?.name}.tagName`,
        operator: "contains",
        values: baseTags,
      },
    ],
  };
  const { data: fetchedTagsResult } = await fetchAndTrackCubeQuery(
    cubejsApi,
    tagsQuery1
  );
  const tagsArray = fetchedTagsResult
    .map((dataArray: any) => {
      return dataArray.map((datapoint: any) => {
        const key: any = Object.keys(datapoint).find((key: any) => {
          return key.includes("tagName");
        });
        return datapoint[key];
      });
    })
    .flat();
  const extractedTagFilterOptions = (tagsArray.length ? tagsArray : []).map(
    (item: string) => {
      return {
        label: item,
        value: item,
        key: item,
        color: "#8476EF",
      };
    }
  );
  setTagFilterOptions(extractedTagFilterOptions);
  setTagFilterOptionsCopy(extractedTagFilterOptions);
};

const getFormattedDate = (timeZone: string, date: string, format: string) => {
  const pstTime = moment.tz(date, format, "America/Los_Angeles");
  const targetTime = pstTime.clone().tz(timeZone);
  return targetTime.format(format);
};

const dateFormatter = (item: any, plantTimeZone: string) => {
  if (moment(item).isValid()) {
    return getFormattedDate(plantTimeZone, item, "MM-DD-YY hh:mm A");
  } else {
    return item;
  }
};

export { getTagsForTagsFilter, dateFormatter };
